import { render, staticRenderFns } from "./HousemateGroupDetail.vue?vue&type=template&id=18eb5d1f"
import script from "./HousemateGroupDetail.vue?vue&type=script&lang=js"
export * from "./HousemateGroupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports